var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKyc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.048,
    height: 64,
    viewBox: "0 0 68.048 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:#002173}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document",
    transform: "translate(-.001 -.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15922",
    fill: "#d4e1f4",
    d: "M251.453 12.5h2.766v3.1h-2.766zm0 0",
    "data-name": "Path 15922",
    transform: "translate(-216.674 -10.34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15923",
    fill: "#cedbfc",
    d: "M173.185 76.574l-.045-.021-6.546-2.794v-4.044a12.062 12.062 0 0 0 5.58-10.168v-.794a3.715 3.715 0 0 0 2.275-4.35 2.973 2.973 0 0 0-2.188-2.2v-3.631a12.241 12.241 0 0 0-3.148-8.2v-7.521a1.939 1.939 0 0 1 1.936-1.936h-2.766a1.939 1.939 0 0 0-1.936 1.936v7.518a12.239 12.239 0 0 1 3.148 8.2v3.633a2.973 2.973 0 0 1 2.188 2.2 3.715 3.715 0 0 1-2.275 4.35v.794a12.062 12.062 0 0 1-5.58 10.168v4.046l6.546 2.794.045.021a6.909 6.909 0 0 1 3.481 4.108h2.766a6.909 6.909 0 0 0-3.481-4.109zm0 0",
    "data-name": "Path 15923",
    transform: "translate(-141.169 -26.208)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12815",
    "data-name": "Group 12815",
    transform: "translate(23.518 .5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15924",
    d: "M170.869 297.438a.83.83 0 0 0 .83-.83v-8.13a.83.83 0 1 0-1.66 0v8.13a.83.83 0 0 0 .83.83zm0 0",
    className: "cls-3",
    "data-name": "Path 15924",
    transform: "translate(-170.039 -247.934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15925",
    d: "M210.973 3.047h-4.621V1.33a.83.83 0 0 0-.83-.83h-25.053a.83.83 0 0 0-.83.83v1.717h-6a3.6 3.6 0 0 0-3.6 3.6V14.6a.83.83 0 1 0 1.66 0V6.643a1.938 1.938 0 0 1 1.936-1.936h6v1.378a.83.83 0 0 0 .83.83h25.052a.83.83 0 0 0 .83-.83V4.707h4.621a1.938 1.938 0 0 1 1.936 1.936v45.895a1.938 1.938 0 0 1-1.936 1.936h-32.354a.83.83 0 0 0 0 1.66h32.359a3.6 3.6 0 0 0 3.6-3.6V6.643a3.6 3.6 0 0 0-3.6-3.6zm-6.281 2.209H181.3V2.16h23.393zm0 0",
    className: "cls-3",
    "data-name": "Path 15925",
    transform: "translate(-170.039 -.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15926",
    d: "M393.616 197.551h-6.067a.83.83 0 0 0 0 1.66h6.067a.83.83 0 1 0 0-1.66zm0 0",
    className: "cls-3",
    "data-name": "Path 15926",
    transform: "translate(-356.75 -170.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15927",
    d: "M346.156 198.381a.83.83 0 0 0 .83.83h2.035a.83.83 0 0 0 0-1.66h-2.035a.83.83 0 0 0-.83.83zm0 0",
    className: "cls-3",
    "data-name": "Path 15927",
    transform: "translate(-321.798 -170.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15928",
    d: "M243.074 197.551H230.04a.83.83 0 0 0 0 1.66h13.033a.83.83 0 0 0 0-1.66zm0 0",
    className: "cls-3",
    "data-name": "Path 15928",
    transform: "translate(-221.027 -170.297)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15929",
    d: "M418.578 262.449h-2.061a.83.83 0 0 0 0 1.66h2.061a.83.83 0 0 0 0-1.66zm0 0",
    className: "cls-3",
    "data-name": "Path 15929",
    transform: "translate(-381.712 -226.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15930",
    d: "M315.477 263.279a.83.83 0 0 0 .83.83H327.3a.83.83 0 1 0 0-1.66h-10.99a.83.83 0 0 0-.833.83zm0 0",
    className: "cls-3",
    "data-name": "Path 15930",
    transform: "translate(-295.362 -226.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15931",
    d: "M290.646 262.449h-.746a.83.83 0 1 0 0 1.66h.742a.83.83 0 0 0 0-1.66zm0 0",
    className: "cls-3",
    "data-name": "Path 15931",
    transform: "translate(-272.611 -226.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15932",
    d: "M230.041 264.109h4.705a.83.83 0 1 0 0-1.66h-4.705a.83.83 0 1 0 0 1.66zm0 0",
    className: "cls-3",
    "data-name": "Path 15932",
    transform: "translate(-221.027 -226.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15933",
    d: "M401.829 322.43h-4.749a.83.83 0 0 0 0 1.66h4.749a.83.83 0 0 0 0-1.66zm0 0",
    className: "cls-3",
    "data-name": "Path 15933",
    transform: "translate(-364.963 -277.904)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15934",
    d: "M371.228 322.43a.83.83 0 0 0 0 1.66h.6a.83.83 0 0 0 0-1.66zm0 0",
    className: "cls-3",
    "data-name": "Path 15934",
    transform: "translate(-342.687 -277.904)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15935",
    d: "M321.728 322.43a.83.83 0 0 0 0 1.66h4.511a.83.83 0 0 0 0-1.66zm0 0",
    className: "cls-3",
    "data-name": "Path 15935",
    transform: "translate(-300.033 -277.904)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15936",
    d: "M230.041 324.09h9.021a.83.83 0 0 0 0-1.66h-9.021a.83.83 0 0 0 0 1.66zm0 0",
    className: "cls-3",
    "data-name": "Path 15936",
    transform: "translate(-221.027 -277.904)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15937",
    d: "M232.893 96.465h-12.606a.83.83 0 0 0-.83.83v6.915a.829.829 0 0 0 .83.83h12.606a.83.83 0 0 0 .83-.83v-6.915a.83.83 0 0 0-.83-.83zm-.83 6.915h-10.946v-5.256h10.946zm0 0",
    className: "cls-3",
    "data-name": "Path 15937",
    transform: "translate(-212.622 -83.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15938",
    d: "M428.077 146.465h-.536a.83.83 0 0 0 0 1.66h.536a.83.83 0 0 0 0-1.66zm0 0",
    className: "cls-3",
    "data-name": "Path 15938",
    transform: "translate(-391.211 -126.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15939",
    d: "M359.17 148.125h5.882a.83.83 0 0 0 0-1.66h-5.882a.83.83 0 1 0 0 1.66zm0 0",
    className: "cls-3",
    "data-name": "Path 15939",
    transform: "translate(-332.296 -126.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15940",
    d: "M394.478 96.465h-5.929a.83.83 0 1 0 0 1.66h5.929a.83.83 0 1 0 0-1.66zm0 0",
    className: "cls-3",
    "data-name": "Path 15940",
    transform: "translate(-357.612 -83.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15941",
    d: "M359.17 98.125h.488a.83.83 0 0 0 0-1.66h-.488a.83.83 0 1 0 0 1.66zm0 0",
    className: "cls-3",
    "data-name": "Path 15941",
    transform: "translate(-332.296 -83.192)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15942",
    fill: "#f0b33f",
    d: "M33.024 123.321v-7.665-.069a6.905 6.905 0 0 0-3.771-5.57l-.048-.017-6.546-2.8v-4.044a12.062 12.062 0 0 0 5.58-10.168V92.2a3.715 3.715 0 0 0 2.275-4.35 2.973 2.973 0 0 0-2.188-2.2v-3.634a12.29 12.29 0 0 0-24.579 0v3.72a2.968 2.968 0 0 0-1.906 2.112A3.715 3.715 0 0 0 4.115 92.2v.794a12.072 12.072 0 0 0 6.251 10.567v3.639L3.82 110l-.045.021A6.905 6.905 0 0 0 0 115.587v7.734a.83.83 0 0 0 .83.83h31.365a.83.83 0 0 0 .83-.83zM5.406 82.016a10.63 10.63 0 0 1 21.26 0v3.778c-2.056.223-8.334.558-13.375-2.785 3.464-.462 7.686-1.525 10.817-3.926a.83.83 0 0 0-1.01-1.317c-5.7 4.369-15.874 3.908-15.975 3.9a.829.829 0 0 0-.871.778L6 86.546l-.541-.278a.106.106 0 0 1-.055-.072zm.369 10.975v-1.422a.83.83 0 0 0-.687-.817 2.052 2.052 0 0 1-1.635-2.509 1.291 1.291 0 0 1 .739-.9 1.754 1.754 0 0 0 .512.4l1.356.7a1.062 1.062 0 0 0 1.54-.863.153.153 0 0 1 0-.016l.257-4.216c.678.007 1.726 0 3-.093 6.777 5.766 16.369 4.156 16.78 4.084a.826.826 0 0 0 .245-.087 1.315 1.315 0 0 1 1.016.991 2.054 2.054 0 0 1-1.635 2.509.83.83 0 0 0-.687.817v1.422a10.4 10.4 0 1 1-20.8 0zm10.4 12.062A12 12 0 0 0 21 104.046v2.979a11.806 11.806 0 0 1-8.973 0v-2.709a12.009 12.009 0 0 0 4.15.737zm15.188 17.439H1.66v-6.8a5.237 5.237 0 0 1 2.84-4.179l6.911-2.949a13.465 13.465 0 0 0 10.214 0l6.91 2.949a5.235 5.235 0 0 1 2.835 4.179zm0 0",
    "data-name": "Path 15942",
    transform: "translate(0 -59.652)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyc);
export default __webpack_public_path__ + "static/media/kyc.6127095f8883410ce8594257e23d62e8.svg";
export { ForwardRef as ReactComponent };